import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import ImageCarousel from "../../core/image/ImageCarousel.tsx";
import Image from "../../core/image/Image";
import { ReactNode } from "react";
import { IconPhotoQuestion } from "@tabler/icons-react";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle.tsx";
import ImageZoom from "../../core/image/ImageZoom.tsx";

const ItemImages = ({
  id,
  fallback = null,
}: {
  id: string;
  fallback?: ReactNode;
}) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  if (isLoading) return LOADING_CIRCLE;
  if (isError) return <ErrMessage message={isError} />;
  if (item.imageUrls.length === 0) return fallback;
  return (
    <div className="w-full">
      <ImageCarousel
        imageUrls={item.imageUrls}
        pageControl={(currentPage, goToPage) => (
          <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-7 gap-2 scroll-auto ">
            {item.imageUrls.map((file, index) => (
              <div
                className={`cursor-pointer relative scale-97 opacity-70 saturate-50 ${currentPage === index && "opacity-100 saturate-100"} hover:scale-100 transition-all `}
                key={"secondary" + file.basename}
                onClick={(e) => {
                  e.stopPropagation();
                  goToPage(index - (currentPage || 0));
                }}
              >
                <Image
                  alt={"Product Image"}
                  className={
                    "aspect-square rounded-box object-cover w-full h-auto"
                  }
                  src={file}
                  sizes={"1024px"}
                />
              </div>
            ))}
          </div>
        )}
        placeholder={
          <div className={`carousel-item relative w-full`}>
            <IconPhotoQuestion stroke={1} className="w-full h-full scale-50" />
            {/* Navigation Buttons */}
          </div>
        }
      >
        {item.imageUrls.map((file) => (
          <div
            key={"primary" + file.basename}
            className="carousel-item items-center w-full"
          >
            <ImageZoom
              alt="Product Image"
              className="absolute inset-0 w-full object-cover h-full rounded-lg"
              src={file}
              sizes="(max-width: 768px) 100vw, 1024px"
            />
          </div>
        ))}
      </ImageCarousel>
    </div>
  );
};
export default ItemImages;
